import React from 'react';
import Column from './column.jsx';

class Columns extends React.Component {

    getColumnsFromChildren(children) {
        let cols = [];
        React.Children.forEach(children, child => {
            if (child.type === Column) {
                let col = {
                    component: child,
                    list: [],
                    combinedWeight: 0
                }

                cols.push(col);
            }
        });

        return cols;
    }

    getShortestColumn(columns) {
        let shortest = {
            combinedWeight: false
        };

        for (var i = 0; i < columns.length; i++) {
            let col = columns[i];
            if (shortest.combinedWeight === false) {
                shortest = col;
            } else if (col.combinedWeight <= shortest.combinedWeight) {
                shortest = col;
            }
        }

        return shortest;
    }

    hydrateColumns(columns, list) {
        list = list || [];
        list.forEach(item => {
            let col = this.getShortestColumn(columns);
            col.list.push(item);
            col.combinedWeight += item.weight;
        });
    }

    renderChildColumns(columns) {
        return columns.map((col, i) => {
            return React.cloneElement(col.component, {
                parent: this,
                list: col.list,
                weight: col.weight,
                key: i
            });
        });
    }

    render () {
        let columns = this.getColumnsFromChildren(this.props.children);
        this.hydrateColumns(columns, this.props.list);

        return (
            <div { ...this.props } className={['component-columns', this.props.className].join(' ')}>
                { this.renderChildColumns(columns, this.props.children) }
            </div>
        )
    }
}

export default Columns;



// WEBPACK FOOTER //
// ./web-app/components/columns.jsx